import { Title } from '@angular/platform-browser';
import { ManualInputData, ListCaption, DyanmicInputUpdate } from 'src/app/models/manualinput/DataSetting';
import { AppDevNotifyComponent } from 'src/app/widgets/dev-notify-bar/dev-notify-bar.component';
import { ManualInputService } from '../manual-input.service';
import { FileExportService } from 'src/app/common/file-export-service';


import { DxDataGridComponent } from 'devextreme-angular';
import { DxDataGridOperator } from 'src/app/operators/dx-data-grid.operator';
import { Subscription } from 'rxjs';
import { CommonHubService, ManualProgressInfo } from 'src/app/services/common.hub.service';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';

@Component({
	selector: 'app-manual-data-update',
	templateUrl: './manual-data-update.component.html',
	styleUrls: ['./manual-data-update.component.scss'],
	standalone: false
})
export class ManualDataUpdateComponent implements OnInit, OnDestroy {

	constructor(
		private readonly manualInputService: ManualInputService,
		private readonly fileExportService: FileExportService,
		private readonly titleService: Title,
		private readonly commonHubService: CommonHubService) { }

	private executionSub!: Subscription;
	private runningExecutions: { id: string, action: string }[] = [];
	columnsDataSource: ListCaption[];
	valuesDataSource: ManualInputData[];
	isStop = false;
	// Map to keep latest progress info keyed by ManualId
	public progressManualInfoMap: { [manualId: number]: ManualProgressInfo } = {};

	@ViewChild('dataGrid', { static: false }) dataGrid: DxDataGridComponent;
	ngOnDestroy() {
		this.isStop = true;
		if (this.executionSub) this.executionSub.unsubscribe();
	}

	ngOnInit() {
		this.isStop = false;
		this.titleService.setTitle("Manual Data Update");
		this.loadPageInfo();
		/* common Hub */
		this.initicommonHub();
		this.GetSettingsData();
	}

	IsExportListEnable = false;
	GetSettingsData() {
		this.fileExportService.WebSettings("EnableExportmanualinputupdateList").subscribe(resultFilename => {
			this.IsExportListEnable = (resultFilename.value.toLowerCase() === "yes");
		}, err => {
			console.log(err, "err");
		});
	}

	reloadData(isLoadershow: boolean = true) {
		this.manualInputService.ReloadDataManualInputs(isLoadershow).subscribe(result => {
			this.valuesDataSource.forEach(items => {
				let item = result.find(x => x.manualId === items.manualId);
				if (item != undefined && item != null) {
					items.status = item.status;
					items.executionMaxTime = item.executionMaxTime;
					items.curentTime = item.curentTime;
					items.isStop = item.isStop;
				}
			});
		}, (err) => {
			AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
		});
	}

	shouldApplyGrouping: boolean;
	loadPageInfo() {
		this.manualInputService.getDynamicTableDataUpdate().subscribe(result => {
			this.valuesDataSource = result.listData;
			this.shouldApplyGrouping = this.valuesDataSource.some(item => item.manualInputGroup != null);
			this.columnsDataSource = result.listCaption;
			this.columnsDataSource.forEach(element => {
				if (element?.field != null && element.field === "errorLog") {
					element.color = "red-color";
				}
			});
			this.reloadData();
		}, (err) => {
			AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
		});
	}

	updateManully(event, data) {
		if (data?.data != undefined && data?.data != null) {
			if (data.data.manualId != undefined && data.data.manualId != null
				&& this.valuesDataSource.find(x => x.manualId === Number( data.data.manualId)) != null) {
				this.valuesDataSource.find(x => x.manualId === Number( data.data.manualId)).status = "In Process";
			}
			const now = new Date();
			// Call the executeStoredProcedure method with the manualId and action
			this.commonHubService.executeStoredProcedure(data.data.manualId, 'start');
		}
	}

	updateStopManully(event, data) {
		this.commonHubService.stopExecution(data.data.manualId.toString());
	}

	onToolbarPreparing(e) {
		const toolbarItems = e.toolbarOptions.items;
		toolbarItems.unshift(
			{
				location: "before",
				template: "columnMode",
			},
			{
				location: 'before',
				template: 'heightButtonTemplate'
			},
			{
				location: 'after',
				template: 'refreshTemp'
			}
		);
		const searchPanel = toolbarItems.filter(item => item.name === 'searchPanel');
		if (searchPanel?.[0]) {
			searchPanel[0].location = 'after';
		}
	}

	refreshPage() {
		this.loadPageInfo();
	}

	inProgress = false;
	seconds = 10;
	maxValue = 10;
	intervalId: number;

	timer() {
		this.seconds--;
		if (this.seconds == 0) {
			this.inProgress = !this.inProgress;
			clearInterval(this.intervalId);
			return;
		}
	}

	format(value) {
		return 'Loading: ' + value * 100 + '%';
	}

	popupUpdateParamVisible: boolean = false;
	ParametersDeclaration: string = "";
	Parameters: string = "";
	updateId = 0;
	updatePopupOpen(data: any) {
		this.popupUpdateParamVisible = true;
		this.Parameters = data.parameters;
		this.ParametersDeclaration = data.parametersDeclaration;
		this.updateId = data.manualId;
	}


	dataDyanmicInputUpdate: DyanmicInputUpdate;
	saveParamters(event) {
		this.dataDyanmicInputUpdate = new DyanmicInputUpdate()
		this.dataDyanmicInputUpdate.id = this.updateId;
		this.dataDyanmicInputUpdate.parameters = this.Parameters;
		this.dataDyanmicInputUpdate.parametersDeclaration = this.ParametersDeclaration;
		this.manualInputService.UpdateDynamicObject(this.dataDyanmicInputUpdate).subscribe(result => {
			if (result.flag > 0) {
				this.loadPageInfo();
				AppDevNotifyComponent.SuccesMessage(result.msg);
				this.popupUpdateParamVisible = false;
			} else {
				AppDevNotifyComponent.ErrorMessage(result.msg);
			}
		}, (err) => {
			AppDevNotifyComponent.ErrorMessage("Sorry, something went wrong. Please try after some time again.");
		});
	}

	compactMode = true;
	onToggleColumnsMode() {
		this.compactMode = !this.compactMode;
		let initialState = JSON.parse(localStorage.getItem('grid-state-manual-update-data'));
		this.dataGrid.instance.state(initialState);
		let currentState = this.dataGrid.instance.state();
		currentState.columns.forEach(col => {
			delete col.width;
		});
		this.dataGrid.instance.state(currentState);
	}

	onDataGridCellPrepared(e) {
		e.cellElement.style.padding = '5px';
	}

	RowCountGroupTempl(data) {
		if (data?.items?.length) {
			return data.items.length;
		}
		if (data?.collapsedItems?.length) {
			return data.collapsedItems.length;
		}
	}

	public dxDataGridOperator: DxDataGridOperator = new DxDataGridOperator();

	public onDataGridContentReady(evt) {
		this.dxDataGridOperator.updateRowCount(evt.component);
		localStorage.setItem('grid-state-manual-update-data', JSON.stringify(this.dataGrid.instance.state()));
	}

	async initicommonHub() {
		// Start the connection first
		await this.commonHubService.startConnection();
		await this.commonHubService.main();

		// Now fetch running executions (getRunningExecutions will wait for connection internally)
		try {
			const executions = await this.commonHubService.getRunningExecutions();
			if (Array.isArray(executions)) {
				this.runningExecutions = executions.map(id => ({ id, action: 'Unknown' }));
			} else {
				this.runningExecutions = [];
			}
		} catch (error) {
			console.error('Error fetching executions:', error);
			this.runningExecutions = [];
		}

		this.commonHubService.activeExecutions$.subscribe(executions => {
			this.runningExecutions = executions;
			this.reloadData(false);
		});

		this.executionSub = this.commonHubService.executionSuccess$.subscribe(result => {
			// Update the status of the item in valuesDataSource based on the result
			if (result && result.id != undefined && result.id != null
				&& this.valuesDataSource.find(x => x.manualId === Number(result.id)) != null) {
				if (result.msg === 'ExecutionStarted') {
					// Handle ExecutionStarted case
					this.valuesDataSource.find(x => x.manualId === Number(result.id)).status = "In Process";
				}
				else if (result.msg === 'ExecutionCompleted') {
					// Handle ExecutionCompleted case
					this.valuesDataSource.find(x => x.manualId === Number(result.id)).status = "Completed";
				}
				else if (result.msg === 'ExecutionStopped') {
					// Handle ExecutionStopped case	
					this.valuesDataSource.find(x => x.manualId === Number(result.id)).status = "Stopped";
				}
				else if (result.msg === 'ExecutionFailed') {
					// Handle ExecutionFailed case
					this.valuesDataSource.find(x => x.manualId === Number(result.id)).status = "Error";
				}
				else if (result.msg === 'ExecutionError') {
					this.refreshPage();
				}
				else {
					this.refreshPage();
				}				
			}
			else {
				console.warn(`No matching manualId found for ID: ${result.id}`);
				this.refreshPage();
			}
		});

		this.commonHubService.onReceiveProgress(progress => {
			// Save/update the incoming progress data keyed by manualId
			this.progressManualInfoMap[progress.manualId] = progress;
			// Optionally update your valuesDataSource array's matching object with new progress info
			const item = this.valuesDataSource.find(x => x.manualId === progress.manualId);
			if (item) {
				item.status = progress.status;
				item.executionMaxTime = progress.executionMaxTime;
				item.curentTime = progress.curentTime;
			}
		});
	}

}